import { SecondaryButton } from '@/Button';
import { SELL_MY_CAR_URL } from '~/constants';
import { useTradeInfo } from '~/contexts/FinanceAndTradeContext';
import TradeIcon from '~/icons/TradeIcon';
import HasTradeCard from './HasTradeCard';

export default function TradeCard() {
  const { status = '' } = useTradeInfo();
  const isActiveOrExpired = status === 'active' || status === 'expired';

  return isActiveOrExpired ? (
    <HasTradeCard />
  ) : (
    <div
      data-qa="apply-trade-in-card"
      className="border border-grey-2 border-solid p-24 rounded-md"
    >
      <h3 className="t-header-s text-blue-6">Add a Trade-in</h3>
      <div className="flex flex-row my-16">
        <div className="mr-16 self-center">
          <TradeIcon />
        </div>
        <p className="t-body-m text-grey-5">
          Share a few vehicle details and we’ll extend a real offer in 2
          minutes.
        </p>
      </div>
      <a
        data-analytics-id="add a trade-in"
        data-native-payload={JSON.stringify({
          action: 'view-trade-offer'
        })}
        href={SELL_MY_CAR_URL}
      >
        <SecondaryButton
          className="!min-h-[40px] w-full"
          data-analytics-id={null}
          type="button"
        >
          Get My Offer
        </SecondaryButton>
      </a>
    </div>
  );
}
